// FeatureCard.js
import React from 'react';
import { Link } from 'react-router-dom';

function CampCard({ backgroundImage, title, date_time, buttonText, linkUrl, earlyBirdPrice, regularPrice, description, location }) {
  return (
    <div
      className="camp-card"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="regiserCardOverlay" />
      <div className="content pt-2">
        <h2>{title}</h2>
        <div className='h3'>
          {date_time}
        </div>
        <Link to={linkUrl} target='_blank'>
          <button type="button">{buttonText}</button>
        </Link>
        <div className='pt-3 lead'>
          {earlyBirdPrice}<br/>
          {regularPrice}
        </div>
        <div className='pt-3 lead ps-3 pe-3 text-start'>
          {description}
        </div>
        <div className='lead pt-2 ps-3 pe-3 pb-3'>
          {location}
        </div>
      </div>
    </div>
  );
}

export default CampCard;
